// src/components/music/constants/musicTypes.js

export const MUSIC_TYPES = [
  { value: 'song', label: 'Song' },
  { value: 'instrumental', label: 'Instrumental' },
  { value: 'piano', label: 'Piano Track' },
  { value: 'minus-one', label: 'Minus 1' },
  { value: 'karaoke', label: 'Karaoke' },
  { value: 'acoustic', label: 'Acoustic' },
  { value: 'cover', label: 'Cover' },
  { value: 'remix', label: 'Remix' },
  { value: 'other', label: 'Other' }
];